var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-attrbuit" },
    [
      _c(
        "el-table",
        {
          staticClass: "table",
          attrs: {
            data: _vm.attrValue,
            height: 400,
            border: "",
            "header-cell-style": { fontWeight: "bold" },
          },
        },
        [
          _vm._l(_vm.attrProps, function (attrProp) {
            return _c("el-table-column", {
              key: attrProp.prop,
              attrs: {
                label: attrProp.label,
                prop: attrProp.prop,
                align: "center",
                "min-width": "120",
                "show-overflow-tooltip": "",
              },
            })
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "规格图片",
              prop: "attrImage",
              "min-width": "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.userType === 1
                      ? _c("div", [
                          scope.row.attrImage
                            ? _c("img", {
                                staticClass: "attr-img pointer",
                                attrs: { src: scope.row.attrImage },
                                on: {
                                  click: function ($event) {
                                    return _vm.attrImage(scope.$index)
                                  },
                                },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-camera cameraIconfont pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.attrImage(scope.$index)
                                  },
                                },
                              }),
                        ])
                      : _c(
                          "div",
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "show-file-list": false,
                                  "before-upload": _vm.beforeAttrImageUpload,
                                  "http-request": function (options) {
                                    return _vm.handleAttrImageUpload(
                                      options,
                                      scope.$index
                                    )
                                  },
                                  accept: "image/*",
                                },
                              },
                              [
                                scope.row.attrImage
                                  ? _c("img", {
                                      staticClass: "attr-img",
                                      attrs: { src: scope.row.attrImage },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont pointer",
                                    }),
                              ]
                            ),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "主图管理",
              prop: "image",
              "min-width": "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleMainImage(scope.row, scope.$index)
                          },
                        },
                      },
                      [_vm._v("主图管理")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "SKU名称",
              prop: "skuName",
              "min-width": "200",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "mini" },
                      model: {
                        value: scope.row.skuName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "skuName", $$v)
                        },
                        expression: "scope.row.skuName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "SKU编码",
              prop: "skuCode",
              "min-width": "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "mini", disabled: "" },
                      model: {
                        value: scope.row.skuCode,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "skuCode", $$v)
                        },
                        expression: "scope.row.skuCode",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "发货码",
              prop: "barCode",
              "min-width": "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "mini" },
                      model: {
                        value: scope.row.barCode,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "barCode", $$v)
                        },
                        expression: "scope.row.barCode",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.productType === 110 ? "面值" : "划线价",
              prop: "otPrice",
              "min-width": "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { controls: false, size: "mini" },
                      model: {
                        value: scope.row.otPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "otPrice", $$v)
                        },
                        expression: "scope.row.otPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "代发成本价",
              prop: "supplyPrice",
              "min-width": "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { controls: false, size: "mini" },
                      model: {
                        value: scope.row.supplyPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "supplyPrice", $$v)
                        },
                        expression: "scope.row.supplyPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "指导价", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.guidePrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "guidePrice", $$v)
                        },
                        expression: "scope.row.guidePrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "控价", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.controlPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "controlPrice", $$v)
                        },
                        expression: "scope.row.controlPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "默认售价", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "mini", controls: false },
                      model: {
                        value: scope.row.defaultPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "defaultPrice", $$v)
                        },
                        expression: "scope.row.defaultPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "集采成本价",
              "min-width": "160",
              align: "center",
              prop: "cpSupplyPrice",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { controls: false, size: "mini" },
                      model: {
                        value: scope.row.cpSupplyPrice,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "cpSupplyPrice", $$v)
                        },
                        expression: "scope.row.cpSupplyPrice",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "集采起订量",
              "min-width": "160",
              align: "center",
              prop: "cpMinQuantity",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { controls: false, size: "mini" },
                      model: {
                        value: scope.row.cpMinQuantity,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "cpMinQuantity", $$v)
                        },
                        expression: "scope.row.cpMinQuantity",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "库存数量",
              "min-width": "160",
              align: "center",
              prop: "stock",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        size: "mini",
                        disabled: _vm.isOneCardProduct,
                      },
                      model: {
                        value: scope.row.stock,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "stock", $$v)
                        },
                        expression: "scope.row.stock",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "库存预警量",
              "min-width": "160",
              align: "center",
              prop: "stockWarning",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        size: "mini",
                        disabled: _vm.isOneCardCreate,
                      },
                      model: {
                        value: scope.row.stockWarning,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "stockWarning", $$v)
                        },
                        expression: "scope.row.stockWarning",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "采销状态", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeCpStatus(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.cpStatus,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "cpStatus", $$v)
                          },
                          expression: "scope.row.cpStatus",
                        },
                      },
                      _vm._l(_vm.cpStatusEnum, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "上下架状态", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeListStatus(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.listStatus,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "listStatus", $$v)
                          },
                          expression: "scope.row.listStatus",
                        },
                      },
                      _vm._l(_vm.goodsStatusEnum, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "毛利率",
              "min-width": "160",
              align: "center",
              prop: "grossMargin",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.checkPermi("grossMargin")
                      ? _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.calculateProfit(scope.row, scope.$index)
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              align: "center",
              width: "100",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteRecord(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("MainImageVue", {
        ref: "mainImageRef",
        on: { mainImageList: _vm.mainImageList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }